<template>
  <div class="display">
    <!-- 顶部地图 -->
    <div class="box">
      <div id="js-container" class="map"></div>
    </div>
    <!-- 固定定位表格的图标 -->
    <!-- <i @click="collectShow=!collectShow" class="iconFrom"></i> -->
    <!-- <div class="iconFrom" @click="collectShow = !collectShow" v-show="!collectShow">
      <i class="iconfont iconche" style="font-size:18px"></i>工作台
      <i class="iconfont iconxiangshang"></i>
    </div>
    <div class="iconFromDiv" v-show="!collectShow"></div> -->

  </div>
</template>
<script>
let MapKey = "42535e7710334eb99119ecb87842af65";
import remoteLoad from "@/components/map/lib/remoteLoad.js";
import moment from "moment";
import {tr_user, village, handStation_list} from "./assets/tr_user";
export default {
  name: "workKanban",
  data() {
    var that = this;
    return {
      newDate: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      // 视频需要传输的
      source: "",
      // 控制视频显示隐藏
      aliplayeShow: false,
      // 地图数据
      dragStatus: false,
      AMapUI: null,
      AMap: null,
      map: null,
      // 车辆实时信息 数据请求
      markers: "",
      // 车辆实时信息state
      // vehicleList: that.$store.state.app.vehicleSto,
      cardShow: false, //轨迹播放按钮显示
      // 表格显示隐藏
      collectShow: false,
      // 报警列表
      columnsTow: [
        {
          fixed: false,
          prop: "alarmType",
          label: "报警类型",
          width: "-",
          render(h, param) {
            var value = "";
            that.alarmType.forEach(function (e) {
              if (e.value == param.row.alarmType) {
                value = e.label;
              }
            });
            return h("div", value);
          },
        },
      ],
      // 报警类型
      alarmStatus: [],
      // 处理状态
      alarmInfoStatus: [],
      //   标签页变量
      activeName: "first",
      //   报警信息列表的接口（分页）
      tableData: [
        {
          id: '',
          licencePlate: "", //车牌号
          alarmTime: "", //报警时间
          alarmType: "", //报警类型
          reason: "", //报警说明
          status: "", //报警状态
          handStationName: "", //处理站名称
          deviceName: "", //设备名称
          worker: "", //作业人员
          tel: "", //电话
        },
      ],
      tableDataTow: [],
      // 车辆状态数据
      vehicleState: "",
      //   分页最初显示那一页
      currentPage: 1,
      currentPageTow: 1,
      //   显示个数
      pageSize: 5,
      pageSizeTow: 5,
      //   总条数
      pageTotal: 400,
      pageTotalTow: 400,
      // 定时器
      timer: "",
      timerShow: true,
      infoWindow: "",
      lineArr: "",
      lineArrTow: [],
      // starshow: "",
      mapCenter: [],
      marker: [],
      markerCan: [],
			markerCanTwo: [],
      // 村庄
      drctVillageForm: "",
			treatmentStationForm: "",
      cluster: "", //点聚合
      // 控制选择
      textData: "开始",
      indexK: 0,
      // 单个点位数据保存
      mak: "",
      // 通道名称选择
      radio: "",
      video: {
        deviceTel: "13520190004", //设备电话
        channel: "1", //通道名称
      },
      videoDetail: "", //视频通道详情,
      numberPlate: "", //视频车牌存储
      // 加载中
      fullscreenLoading: false,
      // 判断是否进行预加载
      fullscreenNum: 0,
      // 收运单位
      markerQizhong: [],
      radioNum: 1,
      carIdArr: [],
      deviceTel: "",
      channel: "",
    };
  },
  async created() {
    // 载入高德地图和UI组件
    Promise.all([
      remoteLoad(`https://webapi.amap.com/maps?v=1.4.4&key=${MapKey}`),
      remoteLoad("https://webapi.amap.com/ui/1.0/main.js"),
      remoteLoad(
        "https://a.amap.com/jsapi_demos/static/demo-center/js/demoutils.js"
      ),
    ]).then(() => {
      this.initMap();
    });
  },
  mounted() {
    var that = this;
    if (window.screen.height == 1080) {
      this.pageSize = 20;
    } else {
      this.pageSize = 10;
    }

    // 处理状态
    // this.alarmInfoStatus = this.$storage.getSelectDict("alarmInfoStatus");
    // this.$WBT.wsMethods.sendMsg(this.$WBT.constWBT.LIVE_CAR_ON, "", {}); //请求实时
  },
  methods: {
    // 地图标记点
    initMap() {
      let that = this;
      var mapCenter = tr_user;
      this.mapCenterData = mapCenter;
      let mapCenterName = mapCenter.unitName;
      mapCenter = [mapCenter.longitude, mapCenter.latitude];
      // mapCenter = ["119.008092", '42.246271'];
      this.mapCenter = mapCenter;
      // 加载PositionPicker，loadUI的路径参数为模块名中 'ui/' 之后的部分
      let AMapUI = (this.AMapUI = window.AMapUI);
      let AMap = (this.AMap = window.AMap);
      let map = (this.map = new AMap.Map("js-container", {
        zoom: 11,
        // center: [119.0087424347726, 42.245061404945744] //初始地图中心点
        center: mapCenter,
        // mapStyle: 'amap://styles/darkblue',
        mapStyle: 'amap://styles/77d6841a4489efd4641de3c982d012d1',
        pitch: 55, // 地图俯仰角度，有效范围 0 度- 83 度
        viewMode:'3D' // 地图模式
      }));
      // 启用工具条
      var gridSize = 60;
      var geolocation;
      this.MarkerCluster = AMap.plugin(
        [
          "AMap.ToolBar", //图例收缩尺
          "AMap.Geocoder",
          "AMap.Geolocation",
          "AMap.MarkerClusterer",
        ],
        function () {
          map.addControl(
            new AMap.ToolBar({
              position: "RB",
            })
          );
          that.cluster = new AMap.MarkerClusterer(
            map, // 地图实例
            {
              gridSize: gridSize, // 设置网格像素大小
              renderClusterMarker: that._renderClusterMarker, // 自定义聚合点样式
              renderMarker: that._renderMarker, // 自定义非聚合点样式
            }
          );
          // 设置点聚合缩放等级
          that.cluster.setMaxZoom(14);
          // 自动中心定位部分
          var geocoder = new AMap.Geocoder({
            map: map,
            radius: 1000, //范围，默认：500
          });
          geolocation = new AMap.Geolocation({
            enableHighAccuracy: true, //是否使用高精度定位，默认:true
            timeout: 10000, //超过10秒后停止定位，默认：无穷大
            maximumAge: 0, //定位结果缓存0毫秒，默认：0
            convert: true, //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
            showButton: true, //显示定位按钮，默认：true
            buttonPosition: "LB", //定位按钮停靠位置，默认：'LB'，左下角
            buttonOffset: new AMap.Pixel(10, 20), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
            showMarker: false, //定位成功后在定位到的位置显示点标记，默认：true
            showCircle: false, //定位成功后用圆圈表示定位精度范围，默认：true
            panToLocation: false, //定位成功后将定位到的位置作为地图中心点，默认：true
            zoomToAccuracy: true, //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
          });
          geofun();
        }
      );
      function geofun() {
        // 把定位插件加入地图实例
        map.addControl(geolocation);
        // 调用定位
        geolocation.getCurrentPosition();
      }
      // let markerQizhong;
      // markerQizhong = new AMap.Marker({
      //   position: mapCenter,
      //   icon: new AMap.Icon({
      //     image: "../../static/img/ksh/qizhongdian1.png",
      //     size: new AMap.Size(100, 100), //图标大小
      //     imageSize: new AMap.Size(100, 100),
      //   }),
      // });
      // markerQizhong.content = `${mapCenterName}`;
      // that.markerQizhong.push(markerQizhong);
      // map.add([markerQizhong]);
      // markerQizhong.on("click", that.markerClick);
      this.Qizhong();
      this.refreshThree();
			this.refreshFour();
    },
    // // 点聚合
    // _renderClusterMarker(context) {
    //   const count = this.markers.length;
    //   let factor = Math.pow(context.count / count, 1 / 18);
    //   let div = document.createElement("div");
    //   let Hue = 180 - factor * 180;
    //   let bgColor = "hsla(" + Hue + ",100%,50%,0.7)";
    //   let fontColor = "hsla(" + Hue + ",100%,20%,1)";
    //   let borderColor = "hsla(" + Hue + ",100%,40%,1)";
    //   let shadowColor = "hsla(" + Hue + ",100%,50%,1)";
    //   div.style.backgroundColor = bgColor;
    //   let size = Math.round(30 + Math.pow(context.count / count, 1 / 5) * 20);
    //   div.style.width = div.style.height = size + "px";
    //   div.style.border = "solid 1px " + borderColor;
    //   div.style.borderRadius = size / 2 + "px";
    //   div.style.boxShadow = "0 0 1px " + shadowColor;
    //   div.innerHTML = context.count;
    //   div.style.lineHeight = size + "px";
    //   div.style.color = fontColor;
    //   div.style.fontSize = "14px";
    //   div.style.textAlign = "center";
    //   context.marker.setOffset(new AMap.Pixel(-size / 2, -size / 2));
    //   context.marker.setContent(div);
    // },
    // _renderMarker(context) {
    //   var content =
    //     '<div style="background-color: hsla(180, 100%, 50%, 0.3); height: 18px; width: 18px; border: 1px solid hsl(180, 100%, 40%); border-radius: 12px; box-shadow: hsl(180, 100%, 50%) 0px 0px 3px;"></div>';
    //   var offset = new AMap.Pixel(-9, -9);
    //   context.marker.setContent(content);
    //   context.marker.setOffset(offset);
    // },
    // 收运单位
    Qizhong() {
      let that = this;
      let AMap = this.AMap;
      let map = this.map;
      let mapCenter = this.mapCenter;
      let mapCenterName = this.mapCenterData.unitName;
      let markerQizhong;
      markerQizhong = new AMap.Marker({
        position: mapCenter,
        icon: new AMap.Icon({
          image: "../../../../static/img/display-img/zhandian-1.png",
          size: new AMap.Size(100, 100), //图标大小
          imageSize: new AMap.Size(45, 63),
        }),
        offset: new AMap.Pixel(-40, -40),
      });
      markerQizhong.content = `${mapCenterName}`;
      that.markerQizhong.push(markerQizhong);
      map.add([markerQizhong]);
      // markerQizhong.on("click", that.markerClick);
    },
		// 地图上村庄及位置和待执行任务数
		refreshThree() {
		  let that = this;
      var res = village;
      res = res.filter((item) => {
        if ( item.latitude && item.longitude){
          if ( item.latitude.indexOf(".") != -1 && item.longitude.indexOf(".") != -1 ) {
            return item;
          }
        }
      });
      that.drctVillageForm = res;
      console.log(res);
      setTimeout(() => {
        that.drctVillageFormMap();
      }, 1000);
		 
		},
    // 点聚 村庄
    drctVillageFormMap() {
      let that = this;
      let AMap = this.AMap;
      let map = this.map;
      let markerCan;
      if (this.drctVillageForm.length != 0) {
        this.drctVillageForm = this.drctVillageForm.filter((item) => {
          if (item.longitude && item.latitude) {
            return item;
          }
        });
        this.drctVillageForm.forEach((item) => {
          markerCan = new AMap.Marker({
            position: [Number(item.longitude), Number(item.latitude)],
            icon: new AMap.Icon({
              // image: "../../../static/img/display-img/renwudidian-1.png",
              image: "../../../../static/img/display-img/cun.png",
              size: new AMap.Size(100, 100), //图标大小
              imageSize: new AMap.Size(30, 42),
            }),
            offset: new AMap.Pixel(-50, -50),
            // anchor: 'top-center',
          });
          item.clickFlag = false;
          // markerCan.content = `<div style="background:red;">
          // ${item.name}<br>任务数:${ item.weight ? item.weight : item.estimatedWasteGeneration ? item.estimatedWasteGeneration : "0" }个 </div>`;
          that.markerCan.push(markerCan);
          map.add([markerCan]);
          that.cluster.addMarker(markerCan);
          // markerCan.on("click", that.markerClick);

          //点击 自定义窗体实例
          let infoWindow = new AMap.InfoWindow({
            isCustom: true,  //使用自定义窗体
            closeWhenClickMap: true, //点击地图 关闭窗体
            content: this.createInfoWindow(item.name, item.taskCount),
            offset: new AMap.Pixel(16, -45)
          });
          //鼠标点击marker弹出自定义的信息窗体
          AMap.event.addListener(markerCan, 'click', function (e) {
              infoWindow.open(map, e.target.getPosition());
          });
        });
      }
    },
    // 自定义信息窗体
    createInfoWindow(name, taskCount) {
        let info ='<div class="bk"><span style="position: absolute; left: 50%; margin: 20px -75px; width: 150px; height: 14px; font-size: 14px; text-align:center;font-weight: bold; color: #FFFFFF;">'
        + name + '</span><span style="position: absolute; margin: 70px -40px 5px 0px; width: 158px; height: 15px; font-size: 12px; font-weight: 400; text-align: center; color: #3598EB;">任务数：</span><span style="position: absolute; margin: 70px 0px 5px 75px; width: 158px; height: 15px; font-size: 12px; text-align: center; font-weight: 400;color: #FFFFFF;">'
        + taskCount + ' 个</span><img style="width: 236px; height: 129px;" src="../../../../static/img/display-img/dialog-bk.png"></div>'
        return info;
    },
    // 地图上处理站
    refreshFour() {
      let that = this;
      var res = handStation_list;
      res = res.filter((item) => {
        if ( item.latitude && item.longitude){
          if ( item.latitude.indexOf(".") != -1 && item.longitude.indexOf(".") != -1 ) {
            return item;
          }
        }
      });
      that.treatmentStationForm = res;
      setTimeout(() => {
        that.treatmentStationFormMap();
      }, 1000);
    },
		treatmentStationFormMap(){
			let that = this;
			let AMap = this.AMap;
			let map = this.map;
			let markerCanTwo;
			if (this.treatmentStationForm.length != 0) {
			  this.treatmentStationForm = this.treatmentStationForm.filter((item) => {
			    if (item.longitude && item.latitude) {
			      return item;
			    }
			  });
			  this.treatmentStationForm.forEach((item) => {
			    markerCanTwo = new AMap.Marker({
			      position: [Number(item.longitude), Number(item.latitude)],
			      icon: new AMap.Icon({
			        image: "../../../../static/img/display-img/cunzhuangdian.png",
			        size: new AMap.Size(100, 100), //图标大小
			        imageSize: new AMap.Size(30, 42),
			      }),
			      offset: new AMap.Pixel(-50, -50),
			      // anchor: 'top-center',
			    });
			    item.clickFlag = false;
			    // markerCan.content = `<div style="background:red;">
			    // ${item.name}<br>任务数:${ item.weight ? item.weight : item.estimatedWasteGeneration ? item.estimatedWasteGeneration : "0" }个 </div>`;
			    that.markerCanTwo.push(markerCanTwo);
			    map.add([markerCanTwo]);
					// 是否放到点聚合里
			    // that.cluster.addMarker(markerCanTwo);
			    // markerCan.on("click", that.markerClick);
			
			    //点击 自定义窗体实例
			    let infoWindow = new AMap.InfoWindow({
			      isCustom: true,  //使用自定义窗体
			      closeWhenClickMap: true, //点击地图 关闭窗体
			      content: this.createInfoWindowTwo(item.name, item.throughput),
			      offset: new AMap.Pixel(-30, -45)
			    });
			    //鼠标点击marker弹出自定义的信息窗体
			    AMap.event.addListener(markerCanTwo, 'click', function (e) {
			        infoWindow.open(map, e.target.getPosition());
			    });
			  });
			}
		},
		// 自定义信息窗体
		createInfoWindowTwo(name, throughput) {
		    let info ='<div class="bk"><span style="position: absolute; margin: 20px -75px; width: 150px; left: 50%; height: 14px; font-size: 14px; text-align: center; font-weight: bold; color: #FFFFFF;">'
		    + name + '</span><span style="position: absolute; margin: 70px -40px 5px 0px; width: 158px; height: 15px; font-size: 12px; text-align: center;  font-weight: 400; color: #3598EB;">处理量：</span><span style="position: absolute; margin: 70px 0px 5px 75px; width: 158px; height: 15px; font-size: 12px; text-align: center;  font-weight: 400;color: #FFFFFF;">'
		    + throughput + ' </span><img style="width: 236px; height: 129px;" src="../../../../static/img/display-img/dialog-bk.png"></div>'
		    return info;
		},

  },
  //离开当前页面
  beforeDestroy() {
    // clearTimeout(this.timer);
    // this.$WBT.wsMethods.sendMsg(this.$WBT.constWBT.LIVE_CAR_OFF, "", {}); //请求实时
    // this.$refs.realPlay.destroy();----
  },
  watch: {
    "$store.state.app.vehicleSto": function () {
      if (this.timerShow && !this.infoWindow.mh && this.lineArr.length == 0) {
        this.markers = this.$store.state.app.vehicleSto;
        this.initMapTow(1);
      }
    },
    radio(val) {
      // if (this.fullscreenNum != 0) {
      this.fullscreenLoading = true;
      // setTimeout(() => {

      // }, 15000);
      // }
      if (this.radio.length != 0 && this.radioNum == 1) {
        this.refVideo();
        this.radioNum = 2;
      } else if (this.radio.length != 0) {
        this.$refs.realPlay.destroy();
        this.videoStop();
        // setTimeout(() => {
        this.refVideo();
        // }, 15000);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.display {
  width: 1920px;
  height: 1080px;
  position: absolute;
}
.box {
  position: relative;
  width: 100%;
  height: 100%;
  .map {
    width: 100%;
    height: 100%;
  }
}
// 底部数据显示
.collect {
  width: 65%;
  position: absolute;
  right: 10%;
  bottom: 0;
  background-color: #fff;
  z-index: 999;
  border-radius: 8px 8px 0px 0px;
  filter: progid:DXImageTransform.Microsoft.Shadow(color=#909090,direction=120,strength=4);
  -moz-box-shadow: 2px 2px 10px #909090;
  -webkit-box-shadow: 2px 2px 10px #909090;
  box-shadow: 2px 2px 10px #909090;
  .btn {
    width: 120px;
    height: 32px;
    line-height: 32px;
    background: rgba(255, 255, 255, 1);
    border-radius: 8px 8px 0px 0px;
    font-size: 15px;
   
    font-weight: 500;
    color: rgba(22, 127, 255, 1);
    position: absolute;
    top: -32px;
    right: 50px;
    display: flex;
    justify-content: space-around;
  }
  .block {
    background-color: #fff;
    margin: 0 0;
    padding: 2px 0;
    height: 35px;
  }
  .vehicle {
    // width: 32%;
    position: absolute;
    top: 12px;
    right: 30px;
    font-size: 13px;
   
    font-weight: 300;
    display: flex;
    justify-content: space-between;
    span {
      margin: 0 10px;
    }
  }
}
// // 车辆图标
// .iconFrom {
//   position: absolute;
//   right: 30px;
//   top: 52%;
//   background: url(../../../static/img/ksh/trolley.png) no-repeat;
//   box-shadow: 0px 1px 2px 0px rgba(135, 173, 221, 1);
//   border-radius: 3px;
//   z-index: 10;
//   font-size: 26px;
//   color: #167fff;
//   width: 38px;
//   height: 36px;
//   line-height: 35px;
// }
.iconFrom {
  width: 120px;
  height: 32px;
  line-height: 32px;
  background: rgba(255, 255, 255, 1);
  border-radius: 8px 8px 0px 0px;
  font-size: 15px;
 
  font-weight: 500;
  color: rgba(22, 127, 255, 1);
  position: absolute;
  right: 13%;
  bottom: 20px;
  display: flex;
  justify-content: space-around;
  filter: progid:DXImageTransform.Microsoft.Shadow(color=#909090,direction=120,strength=4);
  -moz-box-shadow: 2px 2px 10px #909090;
  -webkit-box-shadow: 2px 2px 10px #909090;
  box-shadow: 2px 2px 10px #909090;
}
.iconFromDiv {
  position: absolute;
  right: 10%;
  bottom: 0;
  width: 65%;
  height: 20px;
  background-color: #fff;
  border-radius: 8px 8px 0px 0px;
  filter: progid:DXImageTransform.Microsoft.Shadow(color=#909090,direction=120,strength=4);
  -moz-box-shadow: 2px 2px 10px #909090;
  -webkit-box-shadow: 2px 2px 10px #909090;
  box-shadow: 2px 2px 10px #909090;
}
// 控制按钮
.input-card {
  position: absolute;
  top: 85%;
  left: 45%;
  width: 360px;
  height: 70px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  .input-item {
    width: 80px;
    height: 32px;
    border-radius: 4px;
    .btn {
      width: 100%;
      height: 100%;
      border-radius: 4px;
      border: none;
      color: #fff;
    }
  }
}
// 设置表格文字居中
/deep/.el-table th > .cell {
  text-align: center;
}
/deep/.el-table .cell {
  text-align: center;
}
// 表格头加粗
/deep/.el-table th {
  color: black;
}
.collectShow-enter-active,
.collectShow-leave-active {
  transition: all 1.5s;
}
.collectShow-enter,
.collectShow-leave-to {
  opacity: 0;
  transform: translateY(400px);
}
</style>
<style lang='scss'>
.line {
  width: 100%;
  height: 1px;
  background: #167fff;
  margin-bottom: 20px;
}
.dialogForm {
  .el-dialog__body {
      padding: 0 24px 20px 24px;
  }
  .el-dialog__header {
      padding: 10px;
  }
  .el-dialog__headerbtn {
      top: 8px;
      font-size: 22px;
  }

  .el-form-item__label {
      font-size: 13px;
  }
  .el-dialog {
      border-radius: 4px;
  }
  .realPlayDiv {
    position: relative;
    width: 25%;
    height: 80%;
    position: absolute;
    top: 65px;
  }
  .realPlay {
    position: relative;
    left: 270px;
    width: 70%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProductDetails/mod_screen_display_show/topCenterDisplay.vue